import { Form } from 'factorial-form'

class LegalEntitySelectForm extends Form {
  constructor(values: object) {
    super(values, {
      legal_entity_id: 'string',
      employee_group_id: 'string',
    })
  }
}

export default LegalEntitySelectForm
